<template>
  <div class="develop">
    <div class="headTitle">
      <div class="shadowTxt">DEVELOP</div>
      <div class="title">发展历程</div>
    </div>
    <div class="content">
      <div class="content-item" v-for="activity in showList" :key="activity.id">
        <div class="time">
          <div class="point-line">
            <point :active="true"></point>
          </div>
          <div class="line"></div>
        </div>
        <div class="article">
          <div class="time-show">{{ activity.years }}</div>
          <div class="article-item">{{ activity.title }}</div>
        </div>
      </div>
    </div>
    <div class="moreBox" v-show="activities.length != showList.length">
      <div class="more" @click="showAll = true">
        <div class="moreText">查看更多</div>
        <div class="moreImg"><img src="../../assets/images/bottom.png" alt=""/></div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiGetDevelopment } from "../../api/index";
import Point from "./Point.vue";
export default {
  metaInfo: {
    title: '发展历程-爱情地产',
    meta: [{
      name: 'keyWords',
      content: '爱情地产'
    },
    {
      name: 'description',
      content: ''
    }]
  },
  components: {
    Point,
  },
  data() {
    return {
      activities: [],
      showAll: false,
    };
  },
  computed: {
    showList() {
      return this.showAll ? this.activities : this.activities.slice(0, 5);
    },
  },
  created() {
    apiGetDevelopment().then((data) => {
      this.activities = data.data.course;
    });
  },
};
</script>
<style lang="less" scoped>
.headTitle {
  padding: 20px 15px 7px 15px;
  background: #fff;
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
  }
}
.content {
  margin-top: 35px;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  .content-item {
    display: flex;
    width: 100%;
  }
  .time,
  .article {
    min-height: 110px;
  }
  .time {
    position: relative;
    padding: 0 20px 0 21px;
    .point {
      position: absolute;
      top: 0px;
      right: 4px;
      z-index: 2;
    }
    .line {
      z-index: 1;
      position: absolute;
      right: 12px;
      top: -10px;
      bottom: 10px;
      background: #e9e9e9;
      width: 2px;
    }
  }
  .article {
    margin-left: 20px;
    .time-show {
      font-size: 20px;
      line-height: 26px;
      color: #e95506;
      font-family: "YouSheBiaoTiHei";
      margin-bottom: 5px;
    }
    .article-item {
      font-size: 14px;
      line-height: 20px;
      color: #999;
    }
  }
}

.moreBox {
  padding: 30px 15px;
  img {
    width: 100%;
    height: 100%;
  }
}
.more {
  background: #efefef;
  border-radius: 5px;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  font-family: "苹方-简 中黑体";
  padding: 10px 0px;
  display: flex;
  align-items: center;
  font-weight: 600;
  justify-content: center;
  .moreImg {
    width: 16px;
    height: 16px;
    margin: 2px 0 2px 6px;
    img{
      display: block;
    }
    
  }
}
</style>
